import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { fetchAOTWIfNeeded } from '~/features/actions'
import { DateTime } from 'luxon'
class AOTW extends React.Component {

  componentDidMount() {
    const { match, history, dispatch } = this.props
    dispatch(fetchAOTWIfNeeded())
  }

  render() {
    const { AOTW } = this.props

    if (AOTW.items.length > 0) {
      let item = AOTW.items[0]
      return (
        <div className="margin" id="aotw">
          <div className="art">
            <div style={{ width: '100%' }} className="album">
              <img src={ item.field_image[0].url } />
            </div>
          </div>
          <div className="details">
            <h3>ALBUM OF THE WEEK - { DateTime.fromISO(item.date[0].value).toLocaleString(DateTime.DATE_FULL) }</h3>
            <h2>{ item.title[0].value }</h2>
            <p>{ item.body && item.body[0] && item.body[0].summary}</p>
          </div>
        </div>
      )
    }
    else {
      return null;
    }
  }
}

export default connect(state => { return { AOTW: state.AOTW }}) (AOTW)
